import { VideoInfoProps } from 'features/VideoStatistic/types';
import { ConnectionQuality } from 'livekit-client';
import { observer } from 'mobx-react-lite';
import { ReactComponent as connectionQuality1 } from 'static/connection-quality-1.svg';
import { ReactComponent as connectionQuality2 } from 'static/connection-quality-2.svg';
import { ReactComponent as connectionQuality3 } from 'static/connection-quality-3.svg';
import { selectIsStatisticVisible } from 'state/selectors';
import { VideoInfoView } from './view';

type Props = Omit<VideoInfoProps, 'onVideoSizeChanged'>;

export const VideoInfo: React.FC<Props> = observer(({ connectionQuality, currentBitrate, stats, videoSize }) => {
    const isVisible = selectIsStatisticVisible();

    if (!isVisible || !videoSize) return null;

    const { width, height } = videoSize;

    let ConnectionQualityIndicator: typeof connectionQuality1 | undefined;
    switch (connectionQuality) {
        case ConnectionQuality.Excellent:
            ConnectionQualityIndicator = connectionQuality3;
            break;
        case ConnectionQuality.Good:
            ConnectionQualityIndicator = connectionQuality2;
            break;
        case ConnectionQuality.Poor:
            ConnectionQualityIndicator = connectionQuality1;
            break;
    }

    if (stats) {
        // Непонятно пока насколько полезны именно эти данные, поэтому пока что их просто можем выводить в консоль.
        // console.log("Statistic", stats);
    }

    return (
        <VideoInfoView>
            {ConnectionQualityIndicator && (
                <>
                    <ConnectionQualityIndicator />
                    &nbsp;
                </>
            )}
            <span>
                {width}x{height}px
            </span>
            {currentBitrate !== undefined && currentBitrate > 0 && (
                <span>&nbsp;{Math.round(currentBitrate / 1024)} kbps</span>
            )}
        </VideoInfoView>
    );
});

VideoInfo.displayName = 'VideoInfo';
